"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[SignalingClientVideoSubscriptionConfiguration]] contains a mapping of MID to parameters for customize what remote video is received and how,
 * on an individual stream level. This can be used to update remote video sessions set up through `subscribe`
 */
var SignalingClientVideoSubscriptionConfiguration = function SignalingClientVideoSubscriptionConfiguration() {
  _classCallCheck(this, SignalingClientVideoSubscriptionConfiguration);
};
exports.default = SignalingClientVideoSubscriptionConfiguration;